fx.ns("repositories", class LayoutsRepository extends fx.ModelArray {

    constructor()
    {
        super([]);
        this.endpoint = "/app/layouts";
        this._loaded = {};
        this._nextThemeId = 0;
        this._indexLoaded = 0;
        this.internalSort = this._sortByPosition;
    }
    
    get more()
    {
        return this._nextThemeId;
    }

    get basicLayouts()
    {
        if (!this._basicLayouts || this._basicLayouts.length == 0)
            this._basicLayouts = this.filter( function(layout) { return layout.themeid == -1;} );

        return this._basicLayouts;
    }

    get themeLayouts()
    {
        if (!this._themeLayouts || this._themeLayouts.length == 0)
            this._themeLayouts = this.filter( function(layout) { return layout.themeid != -1;} );

        return this._themeLayouts;
    }

    get simpleThemeLayouts()
    {
        if (!this._simpleThemeLayouts || this._simpleThemeLayouts.length == 0)
            this._simpleThemeLayouts = this.filter( function(layout) { return layout.themeid != -1 && layout.doublepage == 0 && layout.typeid == 1;} );

        return this._simpleThemeLayouts;
    }

    get hasCollectionLayoutsForPage()
    {
        return this.filter( function(layout) { return (layout.product_id != 0 && layout.target == "page"); }).length > 0;
    }

    getLayoutForTheme(themeid)
    {
        return this.filter( function(layout) { return layout.themeid == themeid;} );
    }

    frontCoverLayout(themeid)
    {
        let layout = this.filter(function(layout){ return layout.themeid == themeid && layout.side == "right" && layout.typeid == 6})[0];

        if (!layout)
            layout = this.filter(function(layout){ return layout.themeid == themeid && layout.side == "right"})[0];

        if (!layout)
            layout = this.filter(function(layout){ return layout.side == "right"})[0];

        return layout;
    }

    backCoverLayout(themeid)
    {
        let layout = this.filter(function(layout){ return layout.themeid == themeid && layout.side == "left" && layout.typeid == 6})[0];

        if (!layout)
            layout = this.filter(function(layout){ return layout.themeid == themeid && layout.side == "left"})[0];

        if (!layout)
            layout = this.filter(function(layout){ return layout.side == "left"})[0];

        return layout;
    }

    onUpdated(action)
    {
         super.onUpdated(action);

         // TODO : test this (for config when setting laytou as default, all other ones have to be unsetted)
         if (action.type == "update" && action.impactsOnly("isdefault") && action.tag == "update-default")
         {
            for(let i = 0; i < this.length; i++)
            {
                let layout = this.getItemAt(i);

                if (layout != action.model && layout.product_type_id == action.model.product_type_id && layout.shape == action.model.shape)
                    layout.isdefault = 0;
            }
         }
    }


    init(data)
    {
        super.init(data && data.data ? data.data : data);

        if (data && data.more !== false)
            this._nextThemeId = data.more;
        
        /*if (data && data.data && data.more !== false && data.data.length > 0)
        {
            this._loaded[ data.data[0].themeid + "-" + data.data[0].shape ] = data.more;
            this._initialThemeid = data.data[0].themeid != -1 ? data.data[0].themeid : 0;
        }*/
    }

    getLayoutForPage(number, side, themeid)
    {
        let index = number + ((!side || side == "left") ? 0 : 1);
        let layouts = this.simpleThemeLayouts;

        layouts = layouts.filter(function(layout){ return layout.themeid == themeid; });

        if (layouts.length == 0) return;
        
        while (index >= layouts.length)
            index = index - layouts.length;

        return layouts[index];
    }

    getDefaultLayout(shape)
    {
        let defaultLayout;
        for(let i = 0; i < this.basicLayouts.length; i++)
        {
            let layout = this.basicLayouts.getItemAt(i);

            if (layout.target == "cover" || layout.typeid == 6)
                continue;

            if (layout.isdefault)
            {
                if (!shape || (layout.shape == shape))
                {
                    defaultLayout = layout;
                    break;
                }
            }
        }

        if (!defaultLayout)
        {
            for(let i = 0; i < this.basicLayouts.length; i++)
            {
                let layout = this.basicLayouts.getItemAt(i);
                if (layout.target != "cover" && layout.typeid != 6)
                {
                    defaultLayout = layout;
                    break;
                }
            }
        }

        return defaultLayout;
    }

    getLayoutsWithPhotosDimensions(number, horizontal, vertical, themeid)
    {
        let layouts = this.simpleThemeLayouts.find({num_photos : number, horizontal : horizontal, vertical : vertical, themeid : themeid}, false);

        if (layouts.length == 0)
            layouts = this.basicLayouts.find({num_photos : number, horizontal : horizontal, vertical : vertical, target : "ia"}, false);
        
        if(layouts.length == 0)
        {
            while (layouts.length == 0 && number > 0)   
                layouts = this.basicLayouts.find({num_photos : number--, target : "ia"}, false);
        }

        return layouts;
    }

    getLayoutsWithPhotos(number, themeid)
    {
        let basicLayout = this.basicLayouts.find({num_photos : number, target : "", accountid : 0}, false);
        let themeLayouts = this.simpleThemeLayouts.find({num_photos : number, themeid : themeid, accountid : 0}, false);
        if (themeid == 0 || themeLayouts.length < 2)
            return basicLayout;

        return themeLayouts;
    }

    loadMore(model)
    {
        this.loadThemeLayouts( model, true);    
    }

    loadThemeLayouts( model, from, reset)
    {
        if (reset || this._initialThemeid === undefined)
            this._initialThemeid = model.theme.id;
        
        if (from !== true && from !== undefined)
            this._nextThemeId = from;
        
        let code = this._nextThemeId + "-" +  model.book.shape_option;

        
        if (this._nextThemeId === false)
            this.event("theme-layouts-loaded");
        else
        if (!this._loaded[ code ])
            this.post({ action : "themelayouts", themeid :  this._initialThemeid, shape : model.book.shape_option, from : this._nextThemeId}, this._loadedThemeLayouts);
        else
        {
            this._nextThemeId = this._loaded[ code ].more;
            this.event("theme-layouts-loaded");
        }
    }

    _loadedThemeLayouts(data)
    {
        if (data.error)
        {
            this.event("theme-layouts-error");
        }
        else
        {
            if (data.data && data.data.length > 0)
            {
                let code = data.data[0].themeid + "-" + data.data[0].shape;
                this._loaded[ code ] = data;
                this._nextThemeId = data.more;

                this._indexLoaded++;

                for(let i = 0; i < data.data.length; i++)
                    data.data.getItemAt(i).indexLoaded = this._indexLoaded;
                
                this.addItem( data.data, true );
                
            }
            else
                this._nextThemeId = false;

            this.event("theme-layouts-loaded");
        }
    }

    // --- covers proposed for an automatic album

    /**
     * Asks the server for the covers matching the album (LayoutsController action proposedcovers,
     * CoverProposer on the cover keywords) : signals = { category, points : [{lat, lng}] }. First the
     * covers naming the place, then those of the category, in the editor's language only. They join
     * the repository, so that the panels apply them like any other layout, and
     * "proposed-covers-loaded" is raised.
     */
    loadProposedCovers(signals, shape)
    {
        this._proposed = {};
        this._proposedRequest = (this._proposedRequest || 0) + 1;

        let request = this._proposedRequest;

        this.post({ action : "proposedcovers",
                    shape : shape,
                    category : signals.category || "",
                    points : JSON.stringify(signals.points || []),
                    lang : (typeof fx.currentLang == "function") ? fx.currentLang() : "" },
                  (data) => this._loadedProposedCovers(data, request));
    }

    _loadedProposedCovers(data, request)
    {
        // an older request answering after a newer one (the album classified again)
        if (request != this._proposedRequest || !data || data.error || !data.data)
            return;

        // their rank is kept apart : a cover the repository already holds (the theme of the album)
        // is not added twice, and keeps its own model
        for (let i = 0; i < data.data.length; i++)
        {
            let layout = data.data.getItemAt ? data.data.getItemAt(i) : data.data[i];
            this._proposed[layout.id] = { rank : i, keyword : layout.proposed_keyword, kind : layout.proposed_kind };
        }

        if (data.data.length)
            this.addItem(data.data, true);

        this.event("proposed-covers-loaded", this.proposedCovers);
    }

    /**
     * The covers of a collection product naming where the photos were taken (LayoutsController
     * action placecovers) : ids of the candidate layouts, points = [{lat, lng}]. Answers a Promise of
     * [{ id, keyword }], the most precise place first, [] when none or no answer within `timeout` ms.
     * Their rank is kept (placeRank) and "place-covers-loaded" raised, so that the panels list them first.
     */
    matchPlaceCovers(ids, points, timeout)
    {
        if (!ids.length || !points.length)
            return Promise.resolve([]);

        this._placeRequest = (this._placeRequest || 0) + 1;
        let request = this._placeRequest;

        return new Promise((resolve) => {
            let timer = setTimeout(() => resolve([]), timeout || 10000);

            this.post({ action : "placecovers", ids : JSON.stringify(ids), points : JSON.stringify(points) }, (data) => {
                clearTimeout(timer);

                let matches = (data && !data.error && data.data) ? (data.data.toArray ? data.data.toArray() : data.data) : [];
                matches = matches.map((match) => ({ id : match.id, keyword : match.keyword }));

                if (request == this._placeRequest)
                {
                    this._placeRanks = {};
                    matches.forEach((match, i) => { this._placeRanks[match.id] = i; });
                    this.event("place-covers-loaded", matches);
                }

                resolve(matches);
            });
        });
    }

    /** Rank of a collection cover naming the place of the photos (matchPlaceCovers), undefined for the others. */
    placeRank(layout)
    {
        return (this._placeRanks && layout) ? this._placeRanks[layout.id] : undefined;
    }

    /** The proposed covers, in the order to show them. */
    get proposedCovers()
    {
        let proposed = this._proposed || {};

        return this.filter((layout) => proposed[layout.id] !== undefined)
                   .sort((a, b) => proposed[a.id].rank - proposed[b.id].rank);
    }

    get hasProposedCovers()
    {
        return !!this._proposed && Object.keys(this._proposed).length > 0;
    }

    loadLayouts( themeid, productType, shape, numphotos, all )
    {
        let code = themeid + "-" + productType + "-" + shape + "-" + numphotos;
        
        if (!this._loaded[ code ])
            this.post({ action : "search", search :  numphotos, productType : productType, themeid :  themeid, shape : shape, all : all ? 1 : 0}, this._loadedLayouts);
        else
            this._loadedLayouts(this._loaded[ code ]);
    }

    _loadedLayouts(data)
    {
        if (data.error)
        {
            this.event("layouts-loaded-error");
            return;
        }

       this.addItem( data.data );
             
        let code = data.themeid + "-" + data.productType + "-" + data.shape + "-" + data.numphotos;        
        this._loaded[ code ] = data;
        
        this.event("layouts-loaded");
    }

    use(id, use, history)
    {
        let layout = super.find({id : id});
        if (layout)
            //layout.number = use ? (layout.number + 1) : (layout.number - 1);
            layout.update( {number : use ? (layout.number + 1) : (layout.number - 1)}, {history : !!history} );				
    }


    // --- custom

    hasCustomLayouts()
    {
        let has = false;
        for (let i = 0; i < this.length; i++)
        {
            if (this.getItemAt(i).themeid == -1 && this.getItemAt(i).accountid)
            {
                has = true;
                break;
            }
        }
        return has;
    }

    createCustomLayout(page, side, thumb /*html*/, pageWidth, pageHeight, sliceWidth, shape, accountid)
    {
        let layout = {  shape : shape,
                        doublepage : 0,
                        position : 0,
                        num_photos : 0,
                        num_texts : 0,
                        themeid : -1,
                        visible : 1,
                        bgcolor : page.bgcolor,
                        bgcolorleft : page.bgcolorleft,
                        bgcolorright : page.bgcolorright,
                        width : pageWidth,
                        height : pageHeight,
                        page_id : 0,
                        book_id : 0,
                        side : "",
                        typeid :  page.typeid,
                        accountid : accountid    
                    };
            
        let components = [];
        for (let i = 0; i < page.components.length; i++)
        {
            let component = page.components.getItemAt( i );
            let bounding = fx.graphics.getBoundingRect(component, component.rotation);

            // the slice text belongs to the book, not to a side : rotated across the slice, it
            // passes both side tests, and every application of the layout would add a copy of it
            if (component.isSliceText)
                continue;

            if ( component.isBackground)
            {
                if (component.creation != side)
                    continue;
            }
            else
            if (  (side == "left" && bounding.x >= pageWidth) ||
                    (side == "right" && bounding.x + bounding.width <= pageWidth) 
                )    
                continue;

            if (component.isPhoto)
                layout.num_photos++;
            else
            if (component.isText)
                layout.num_texts++;

           

            let json = component.JSON();
            delete json.zoom;
            delete json.creation_element_id;
            delete json.x_inner;
            delete json.y_inner;
            delete json.width_inner;
            delete json.height_inner;
            delete json.rotation_inner;
            delete json.line_height;
            delete json.lastaction;
            delete json.contentlines;

            if (side == "right")
            {
                json.x -= pageWidth;
                if (page.isCover)
                    json.x -= sliceWidth;
            }
            

            if (component.isPhoto)
                json.content = "";

            components.push( json );
        }

        
        let data = {    'action' : "customlayout",
                        'platform': "desktop",
                        //'code': html ,
                        'thumb' : thumb,
                        'side': side ,
                        'width': pageWidth ,
                        'height': pageHeight ,
                        'slice': page.isCover ? sliceWidth : 0,
                        'layout': layout ,
                        'components': components };

        this.post(data, this._customLayoutCreated);

        this.event("custom-layout-creating");
    }

    _customLayoutCreated(data)
    {
        if (data.error)
            this.event("custom-layout-error");
        else
        {
             let layout = this.addItem( new models.ThemeLayout(data) );
             this.event("custom-layout-created", layout);
        }
    }


    onDataEvent(e)
    {
        let layout = e.model;

        if(e.type == "position-up")
        {
            this.updatePosition(layout);

            let layouts = this.getLayouts(layout);

            let index = layouts.indexOf( layout );
            if (index > 0)
            {
                let previousLayout = layouts.getItemAt( index - 1);
                let actualPosition = layout.position;
                layout.position = previousLayout.position;
                previousLayout.position = actualPosition;

                this.updatePosition(layout);
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-down")
        {
            this.updatePosition(layout);

            let layouts = this.getLayouts(layout);

            let index = layouts.indexOf( layout );
            if (index < layouts.length-1)
            {
                let previousLayout = layouts.getItemAt( index + 1);
                let actualPosition = layout.position;
                layout.position = previousLayout.position;
                previousLayout.position = actualPosition;

                this.updatePosition(layout);
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-up-10")
        {
             this.updatePosition(layout);

            let layouts = this.getLayouts(layout);

            let index = layouts.indexOf( layout );
            if (index > 0)
            {
                let previousLayout = layouts.getItemAt( Math.max(0, index - 10));
                layout.position = previousLayout.position - 0.5;
                
                this.updatePosition(layout);
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-down-10")
        {
            this.updatePosition(layout);

            let layouts = this.getLayouts(layout);

            let index = layouts.indexOf( layout );
            if (index < layouts.length-1)
            {
                let previousLayout = layouts.getItemAt(  Math.min( layouts.length-1, index + 10) );
                layout.position = previousLayout.position + 0.5;
                
                this.updatePosition(layout);
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-first")
        {
            this.updatePosition(layout);

            let layouts = this.getLayouts(layout);

            let index = layouts.indexOf( layout );
            if (index > 0)
            {
                let previousLayout = layouts.getItemAt( 0);
                layout.position = previousLayout.position - 1;

                this.updatePosition(layout);
                this.event("position-updated");
            }

        }
        else
        if(e.type == "position-last")
        {
            this.updatePosition(layout);

            let layouts = this.getLayouts(layout);

            let index = layouts.indexOf( layout );
            if (index < layouts.length-1)
            {
                let previousLayout = layouts.getItemAt( layouts.length-1);
                layout.position = previousLayout.position + 1;

                this.updatePosition(layout);
                this.event("position-updated");
            }
        }
        
    }

    getLayouts(layout)
    {
        let layouts = this.filter( (l) => l.shape == layout.shape && l.collection_id == layout.collection_id && l.product_type_id == layout.product_type_id && l.target == layout.target && l.id_lang == layout.id_lang && l.themeid == layout.themeid)
        layouts.sort(function(a, b){ return a.position - b.position});
        return layouts;
    }
    updatePosition(layout)
    {
        let layouts = this.getLayouts(layout);

        for (let i = 0; i < layouts.length; i++)
        {
            let layout = layouts.getItemAt(i);
            layout.position = i;
        }
    }

     _sortByPosition(a, b)
    {
        if (a.details == b.details)
        {
            if (a.position !== undefined && a.position !== undefined)
                return a.position - b.position;
            else
                return a.id - b.id;
        }
        else
        {
            if (a.details == "" && b.details != "")
                return -1;

            if (a.details != "" && b.details == "")
                return 1;
        }
    }

});